import {
  createReducer,
  createRequestReducer
} from 'pobble-components/dist/redux-helpers'
import { combineReducers } from 'redux'

const handleStateError = (state, { error }) => ({
  ...state,
  pending: false,
  error: error.response
})

const defaultState = {
  initial: true,
  pending: false,
  error: null,
  actionDone: false,
  linkResent: false
}

const MagicLink = combineReducers({
  sendAnotherRequest: createRequestReducer('MAGIC_LINK:SEND_ANOTHER'),
  linkState: createReducer(defaultState, {
    'MAGIC_LINK:ACTION_REQUEST': state => ({
      ...state,
      initial: false,
      pending: true
    }),
    'MAGIC_LINK:ACTION_REQUEST_SUCCESS': (state, { params }) => ({
      pending: false,
      error: null,
      actionDone: params.actionName
    }),
    'MAGIC_LINK:FETCH_INFO_REQUEST_ERROR': handleStateError,
    'MAGIC_LINK:ACTION_REQUEST_ERROR': handleStateError,
    'MAGIC_LINK:SEND_ANOTHER_REQUEST_SUCCESS': state => ({
      ...state,
      linkResent: true
    })
  }),
  link: createReducer(null, {
    'MAGIC_LINK:FETCH_INFO_REQUEST_SUCCESS': (state, { response }) =>
      response.data
  })
})

export default MagicLink
